@if (entry.base?.display && !displaySpinner) {
  <!-- FORM -->
  @if (electionQuestionsForm) {
  <form [formGroup]="electionQuestionsForm"
    (ngSubmit)="addPostElectionQuestionValidatedQuestions(electionQuestionsForm)" class="election-questions-form">

    <!-- CATEGORIES -->
    @for (category of electionQuestionsForm.controls | keyvalue: valueAscOrder; track category.key; let i = $index) {
    <div>
      <div class="label">
        {{getContent('category', category.key)}}
      </div>
      <div [formGroupName]="category.key">
        <!-- QUESTIONS-->
        @for (control of category.value.controls | keyvalue: questionInOrder; track control.key) {
          @switch (isFormGroup(control.value)) {
            @case (true) {
            <div [formGroupName]="control.key">
              <div class="custom-checkbox">
                <mat-checkbox [formControlName]="'eventValue'" #checkbox>
                </mat-checkbox>
                <div>
                  {{getContent('question', control.key)}}
                </div>
              </div>
              @if (checkForRadio(control.key) && checkbox.checked) {
              <div class="radio-container">
                {{questionRadio}}
                <mat-radio-group [formControlName]="'radio'" class="triggered-radio-group">
                  @for (option of getRadioOptionsById(control.key) | keyvalue; track option.key; let i = $index) {
                    <mat-radio-button [value]="option">
                      {{option.value}}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
              }
              @if (checkForDate(control.key) && checkbox.checked) {
              <div class="date-container">
                {{questionDate}}
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>MM/DD/YYYY</mat-label>
                    <input matInput [matDatepicker]="picker" [formControlName]="'date'" min="{{minDate}}"
                      max="{{maxDate}}">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker startView='year'></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              }
            </div>
            }
            @default {
            <div class="custom-checkbox">
              <mat-checkbox [formControlName]="control.key" #checkbox [checked]="isNewInd">
              </mat-checkbox>
              <div>
                {{getContent('question', control.key)}}
              </div>
            </div>
            }
          }
        }
      </div>
    </div>
    }

    @if (entry.custom?.disclaimerText) {
      <em><br/>{{entry.custom?.disclaimerText}}</em>
    }

    <button [disabled]="!electionQuestionsForm.valid" mat-raised-button color="primary">VIEW EFFECTIVE DATES</button>
  </form>
  }
}

@if (displaySpinner) {
  <mat-spinner></mat-spinner>
}

@if (!effectiveDateRadioForm.valid) {
  <mat-error>
    Please select the appropriate enrollment reason(s) above, then click VIEW EFFECTIVE DATES to choose a coverage effective date.
  </mat-error>
}

<section [hidden]="!displayDateSelectionSection">
  <div class="election-selection-section">
    <form [formGroup]="effectiveDateRadioForm">
      <div class="election-period-label">Your Election Period</div>
      <mat-radio-group [required]="true" name="radioGroup" [formControlName]="'effectiveDate'">
        @for (effectiveDatePossibility of effectiveDatePossibilities; track $index; let effectiveDatePossibilityIndex = $index) {
        <div>
          <div class="date-option-container">
            <label>{{effectiveDatePossibility.label}}</label>

            @for (electionQuesDate of effectiveDatePossibility.subInputs; track $index; let electionQuesDateIndex = $index) {
            <mat-radio-button [value]="electionQuesDate" (change)="effectiveDateRadioChange($event, electionQuesDate.key)">
              {{electionQuesDate.key}}
            </mat-radio-button>
            }

            @if (!effectiveDatePossibility.subInputs?.length) {
              No option for selected date
            }
          </div>
        </div>
        }
      </mat-radio-group>
    </form>
  </div>

  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"></form>
</section>